import gql from 'graphql-tag'

export const updateNews = ({ newsId, newsData, newsRoles }) => {
	return {
		mutation: gql`
			mutation (
				$news_id: bigint!
				$object: news_set_input!
				$roles: [news_roles_insert_input!]!
			) {
				update_news_by_pk(pk_columns: { id: $news_id }, _set: $object) {
					id
				}
				delete_news_roles(where: { news_id: { _eq: $news_id } }) {
					affected_rows
				}
				insert_news_roles(objects: $roles) {
					affected_rows
				}
			}
		`,
		variables: {
			object: newsData,
			news_id: newsId,
			roles: newsRoles.map(rol => ({
				news_id: newsId,
				rol_id: rol.id
			}))
		}
	}
}
